<template>
  <div :class="'item ' + oshirase.oshirase_type" v-bind:class="{ 'no-action': !hasControl && !canReaded }">
    <span class="title-wrapper">
      <span class="date">{{ dateFormat(oshirase.start_datetime) }}</span>
      <span class="title pre">{{ oshirase.title }}</span>
    </span>
    <span class="action" v-if="(hasControl || canReaded)" v-on:click="action()">
      {{ oshirase.control_text ? oshirase.control_text : '既読にする' }}
    </span>
  </div>
</template>

<script lang="ts">
import { dateFormat } from '@/filters/common';
import router from '@/routers';
import { OshiraseData } from '@/types/Oshirase';
import { computed } from '@vue/reactivity';
import { defineComponent } from 'vue'
import { OshiraseService } from "@/service/OshiraseService";
import { RouterConst } from '@/const/Router';
import { isNavigationFailure } from 'vue-router';

export default defineComponent({
  props: {
    oshirase: {
      type: Object as () => OshiraseData,
      required: true
    }
  },
  emits: ['destroy'],
  setup(props, context) {

    const oshiraseService = new OshiraseService();

    // サーバーからの指定操作有無
    const hasControl = computed(() => {
      return props.oshirase.control_type ? true : false
    })

    // サーバーからの指定操作
    const action = async () => {
      console.log('tap', props.oshirase);

      // 既読可で、コントロールタイプが無い場合はそのまま既読扱いとする  MEDICA_AS-1287 対応
      // 打刻が承認されたお知らせが、この分岐対象としてある
      if (canReaded.value && !hasControl.value) {
        await read()
        return
      }

      if (!hasControl.value) {
        return
      }

      let result
      switch (props.oshirase.control_type) {
        case RouterConst.KINMU_LIST:
          result = await router.push({ name: RouterConst.KINMU_LIST, query: { dakoku_id: props.oshirase.target_id } })
          break
        case 'shinsei':
          result = await router.push({ name: RouterConst.SHINSEI_DETAIL, params: { id: props.oshirase.target_id } })
          break;
        case 'koyoukeiyaku':
          result = await router.push({ name: RouterConst.KOYOUKEIYAKU_DETAIL, params: { id: props.oshirase.target_id } })
          break;
        case 'renraku':
          result = await router.push({ name: RouterConst.RENRAKU_DETAIL, params: { id: props.oshirase.target_id } })
          break;
        case 'summaryOshirase':
          result = await router.push({ name: RouterConst.OSHIRASE_LIST, params: { id: props.oshirase.target_id } })
          break;
        case RouterConst.SYAIN_DETAIL:
          result = await router.push({ name: RouterConst.SYAIN_LIST, params: { id: props.oshirase.target_id } })
          break;
      }
      if (canReaded.value && !isNavigationFailure(result)) {
        await read()
      }
      return;
    }

    // 既読可否
    const canReaded = computed(() => {
      return props.oshirase.is_can_readed
    })

    // 既読処理
    const read = async () => {
      await oshiraseService.updateToRead(props.oshirase.oshirase_id);
      context.emit('destroy', true);
    }

    return {
      action,
      dateFormat,
      canReaded,
      hasControl
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/oshirase-item.scss';
</style>
